import React from 'react';
import { BarcodeOutlined } from '@ant-design/icons';
import {
  SHIP_LABEL_ORDER_STATUS,
  shipLabelStatusLabel,
  shipLabelStatusTitle,
} from '../../utils/shippingLabelOrderStatus';
import '../../styles/lscOrderStatusChips.css';
import './ShipLabelStatusChip.css';

/**
 * Carrier ship-label status chip (Printing Orders + Packers cards).
 * Click jumps to Wave / Labels desk — no inline upload (contract 2B).
 */
export default function ShipLabelStatusChip({
  status = SHIP_LABEL_ORDER_STATUS.MISSING,
  pageCount = 0,
  onOpenDesk,
  className = '',
}) {
  const tone =
    status === SHIP_LABEL_ORDER_STATUS.ATTACHED
      ? 'is-attached'
      : status === SHIP_LABEL_ORDER_STATUS.NEEDS_CHECK
        ? 'is-needs-check'
        : 'is-missing';
  const label = shipLabelStatusLabel(status);
  const detail =
    status === SHIP_LABEL_ORDER_STATUS.ATTACHED && pageCount > 0
      ? ` · ${pageCount}`
      : '';

  return (
    <button
      type="button"
      className={`ship-label-status-chip ${tone}${className ? ` ${className}` : ''}`}
      title={shipLabelStatusTitle(status)}
      aria-label={`${label}. Open Wave desk for shipping labels.`}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof onOpenDesk === 'function') onOpenDesk();
      }}
    >
      <BarcodeOutlined aria-hidden="true" />
      <span>
        {label}
        {detail}
      </span>
    </button>
  );
}
